import { useTranslation } from '@gimlite/common';
import { Blurb, Row, Zone } from '@gimlite/ui-v1';
import { PoolAdminAction } from '../action/pool-admin.action';

export declare namespace PoolAdminLineType {
  type Props = {
    data: {
      firstName: string | null;
      lastName: string | null;
      email: string | null;
    };
  };
}

export const PoolAdminLine = ({
  data: { firstName, lastName, email },
}: PoolAdminLineType.Props) => {
  const { t } = useTranslation();

  return (
    <Zone
      config={{
        gap: {
          x: 1,
          y: 0,
        },
        zones: [['identity', 'action']],
        rows: ['1fr'],
        columns: ['1fr', 'min-content'],
        vertical: 'center',
        horizontal: 'center',
      }}
    >
      <Zone.Area config={{ area: 'identity' }}>
        <Blurb
          data={{
            title:
              `${lastName || ''} ${firstName || ''}`.trim() || t('unknown'),
            description: email ? `${email}` : '',
          }}
        />
      </Zone.Area>

      <Zone.Area config={{ area: 'action' }}>
        <Row config={{ horizontal: 'center', vertical: 'center' }}>
          <PoolAdminAction config={{ size: 'list' }} />
        </Row>
      </Zone.Area>
    </Zone>
  );
};
